import React from 'react';
import NavBar from "../_components/NavBar/NavBar";
import { SectionDetail, Header, Body } from "./style";
import { useSelector } from "react-redux";

const HomePage = ( props ) => {

    const { user } = useSelector( state => state.repository)
    const { bookingBar, navBar } = useSelector( state => state.ui)

    return (
        <>
            <SectionDetail>
                <div className="container-fluid nopadding noborder, nomargin clearfix">

                    {
                        navBar &&
                        <div>
                            {
                                user &&
                                <Header>
                                    <NavBar/>
                                </Header>
                            }

                        </div>
                    }
                    <Body>
                        <div className="fondo-degradado clearfix">
                            {props.children}
                        </div>

                    </Body>
                </div>
            </SectionDetail>

        </>
    )
}

export default HomePage;